/*
const ORDER = 'Order';
const ITEM = 'Item';
const AUTH = 'Auth';
const CATEGORY = 'Category';
const CUSTOMERS = 'Customers';
const RECIPE = 'Recipe';
const RECIPES = 'Recipes';
const USER = 'User';
const FILLING = 'Filling';
const FILLINGS = 'Fillings';
const RECIPES_LIGHT = 'RecipesLight';
const RECIPES_FOR_ORDER = 'RecipesForOrder';
const UNREVIEWED_ORDERS = 'UnreviewedOrders';
const PRODUCT_TYPE = 'ProductType';
const PACKAGES_LIGHT = 'PackagesLight';
// TODO: need to use core types and later add id e.g. { type: 'Order', id: 'search' }
export const tagTypes = [ORDER, ITEM, AUTH, CATEGORY, CUSTOMERS, RECIPE, RECIPES, USER, FILLING, FILLINGS,
    RECIPES_LIGHT, RECIPES_FOR_ORDER, UNREVIEWED_ORDERS, PRODUCT_TYPE, PACKAGES_LIGHT];
*/


export const TAGS = {
    ORDER: 'Order',
    ORDER_V2: 'OrderV2',
    ITEM: 'Item',
    AVAILABLE_ITEM_NAMES: 'AVAILABLE_ITEM_NAMES',
    AUTH: 'Auth',
    CUSTOMERS: 'Customers',
    RECIPE: 'Recipe',
    RECIPE_PARTS: 'RecipeParts',
    RECIPE_PART_CATEGORIES: 'RecipePartCategories',
    RECIPES: 'Recipes',
    USER: 'User',
    FILLING: 'Filling',
    FILLINGS: 'Fillings',
    FILLINGS_LIGHT: 'FillingsLight',
    RECIPES_LIGHT: 'RecipesLight',
    RECIPES_FOR_ORDER: 'RecipesForOrder',
    UNREVIEWED_ORDERS: 'UnreviewedOrders',
    PRODUCT_TYPE: 'ProductType',
    PACKAGES_LIGHT: 'PackagesLight',
    PACKAGES: 'Packages',
    PACKAGES_FOR_ORDERS: 'PackagesForOrders',
    AVAILABLE_PACKAGE_NAMES: 'AVAILABLE_PACKAGE_NAMES',
    DECORATIONS: 'Decorations',
    DECORATIONS_FOR_ORDER: 'DecorationsFoOrder',
    DECORATION: 'Decoration',
    ANALYTICS: 'Analytics',
    FINANCES: 'Finances',
    EXPENSE_CATEGORIES: 'ExpenseCategories',
    ADMIN_DASHBOARD: 'AdminDashboard',
    ADMIN_USERS: 'AdminUsers',
    ADMIN_BUSINESSES: 'AdminBusinesses',
    ADMIN_EVENTS: 'AdminEvents',
    EARLY_ACCESS_APPLICATIONS: 'EarlyAccessApplications',
    ADMIN_FEEDBACK: 'AdminFeedback',
} as const;

// 🔹 Массив для передачи в RTK Query
export const tagTypes = Object.values(TAGS);
